import { useEffect, useState } from "react";
import { AgentOSLayout } from "@/components/agent-os/AgentOSLayout";
import { apiFetch, Empty, formatDateTime, JsonPreview, Pill, Spinner } from "@/components/agent-os/shared";

export default function AgentOSMemory() {
    const [items, setItems] = useState(null);
    const [scope, setScope] = useState("");
    useEffect(() => { apiFetch(`/memory${scope ? `?scope=${scope}` : ""}`).then((r) => (r.ok ? r.json() : [])).then(setItems); }, [scope]);

    return (
        <AgentOSLayout title="Memory" subtitle="Task, agent and organizational memory with scoped writes, retention metadata and auditability.">
            <div className="mb-6 flex gap-2" data-testid="memory-filters">
                {["", "task", "agent", "organization"].map((value) => <button key={value || "all"} type="button" data-testid={`memory-filter-${value || "all"}`} onClick={() => setScope(value)} className={`border px-4 py-2 text-[10px] font-semibold uppercase tracking-[0.16em] ${scope === value ? "border-forest bg-forest text-ivory" : "border-ink/15 text-ink/55"}`}>{value || "all"}</button>)}
            </div>
            {!items ? <Spinner /> : items.length === 0 ? <Empty title="No memory entries" copy="Approved task, agent or organizational memory will appear here." /> : (
                <div className="grid gap-4 xl:grid-cols-2" data-testid="memory-list">
                    {items.map((item) => (
                        <article key={item.memory_id} data-testid={`memory-${item.memory_id}`} className="border border-ink/10 bg-ivory p-6">
                            <div className="flex flex-wrap items-center gap-2"><Pill value={item.scope} /><Pill value={item.status} /></div>
                            <h2 className="mt-3 font-serif text-2xl font-medium">{item.key}</h2>
                            <p className="mt-1 text-xs text-ink/45">{item.agent_id} · {item.task_id || "no task"} · retention {item.retention_days} days · {formatDateTime(item.created_at)}</p>
                            <div className="mt-5"><JsonPreview value={item.value} /></div>
                        </article>
                    ))}
                </div>
            )}
        </AgentOSLayout>
    );
}
